import EmptyState from "@/components/EmptyState";
import { useNavigate } from "@/router";
import CareerPlanSummaryCard from "./_CareerPlanSummaryCard";
import { getHubCareerGoalRows } from "./careerPlanHubSummaries";
import { careerProfileGoalsHref } from "./careerPlanLatest";
import type { CareerPlanGoal } from "./careerPlanHistory";

export default function CurrentCareerGoalsCard({
  goal,
  loading,
  pgaId,
  hasArchivedCareerGoals = false,
  canManageCareerPlan = false
}: {
  goal: CareerPlanGoal | null;
  loading: boolean;
  pgaId?: string;
  /** True when inactive Intent versions exist (even if there is no active Intent). */
  hasArchivedCareerGoals?: boolean;
  canManageCareerPlan?: boolean;
}) {
  const navigate = useNavigate();
  const rows = getHubCareerGoalRows(goal);
  const createAction =
    canManageCareerPlan && pgaId
      ? {
          children: "Create Check-In",
          icon: "add" as const,
          testId: "career-goals-create-empty",
          onClick: () => navigate("/people/:pgaId/career/career-profile/goals", { params: { pgaId } })
        }
      : undefined;

  return (
    <CareerPlanSummaryCard
      title="Check-In"
      testId="current-career-goals"
      updatedAt={goal?.updatedAt}
      loading={loading}
      viewAllHref={pgaId ? careerProfileGoalsHref(pgaId) : undefined}
      showViewAll={!!goal}
      options={
        goal
          ? rows.map((row) => ({
              iconName: row.iconName,
              overline: row.label,
              headline: row.value,
              longContent: true
            }))
          : []
      }
    >
      {!goal ? (
        <div className="flex min-h-0 w-full flex-1 flex-col items-center justify-center">
          <EmptyState
            iconName="track_changes"
            title="No Check-In"
            caption={
              hasArchivedCareerGoals
                ? "This person does not have an active Check-In."
                : "This person has not submitted a Check-In yet."
            }
            action={createAction}
          />
        </div>
      ) : null}
    </CareerPlanSummaryCard>
  );
}
